import React, { useMemo } from 'react';
import { Modal, Typography, Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'; // Material UI icon
import './ErrorOverlay.css'; // Import your CSS file

const ErrorOverlay = ({ error, onBackdropPress, visible }) => {
  const errorMessage = useMemo(() => {
    return error?.response?.data?.message || error?.response?.data?.error?.message || error?.message || null;
  }, [error]);

  return (
    <Modal
      open={visible}
      onClose={onBackdropPress}
      aria-labelledby="error-overlay-title"
      aria-describedby="error-overlay-description"
    >
      <Box className="error-overlay-container">
        <ErrorOutlineIcon fontSize="large" color="error" />
        <Typography id="error-overlay-description" variant="h6" component="div" className="error-message">
          {!errorMessage ? "Check your connection then try again!" : errorMessage}
        </Typography>
      </Box>
    </Modal>
  );
};

export default ErrorOverlay;
